import React, { useRef } from 'react';
import Modal from 'cccisd-modal';
import PropTypes from 'prop-types';
import axios from 'cccisd-axios';
import GuAdminSupervisorForm from '../../../../components/Manage/GuAdminSupervisorForm';

import IconPlus from 'cccisd-icons/plus-circle2';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;

const AddGuAdminSupervisorForm = props => {
    const modal = useRef();

    const { loadData, settings } = props;

    const onSubmit = async (values, training) => {
        try {
            const userValues = {
                role: settings.role,
                username: values.username,
                user: values.existingUser ? values.username : null,
                first_name: values.firstName,
                last_name: values.lastName,
                idNumber: values.idNumber,
                email: values.username,
                group: values.gUnit,
            };

            // if user already exists, we don't need to send the username in the POST
            values.existingUser && delete userValues.username;

            const previouslyTrainedValues = training;

            const response = await axios.post(Boilerplate.route('api.nexus.pawn.store'), {
                ...userValues,
                ...previouslyTrainedValues,
            });

            if (response.data.errors) {
                return Promise.reject(response.data.errors);
            }

            await loadData();
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <Modal
            ref={modal}
            trigger={
                <button type="button" className="btn btn-primary">
                    <span>
                        <IconPlus spaceRight />
                        {settings.role === 'guAdmin' ? 'Add Local Coordinator' : 'Add Supervisor'}
                    </span>
                </button>
            }
            title={settings.role === 'guAdmin' ? 'Add New Local Coordinator' : 'Add New Supervisor'}
        >
            <GuAdminSupervisorForm onSubmit={onSubmit} operation="create" role={settings.role} />
        </Modal>
    );
};

AddGuAdminSupervisorForm.propTypes = {
    loadData: PropTypes.func,
    settings: PropTypes.object,
};

export default AddGuAdminSupervisorForm;
